import React from 'react';
import {FaCalendar, FaCamera} from "react-icons/fa";
import { FaLocationDot} from "react-icons/fa6";
import DivisorItem from "./divisor-item.jsx";
import projectUtils from "../../../../../../../utils/project-utils.js";

const PassageDetails = ({data}) => {
    const cameraDetails = () => {
        const lanePrefix = data.laneCode ? `${data.laneCode} - ` : "";
        const routePart = data.routeDescription ? `${lanePrefix}${data.routeDescription}` : "";
        const lanePart = data.laneName ?? "";

        return routePart && lanePart ? ` (${routePart}: ${lanePart})` : routePart ? ` (${routePart})` : lanePart ? ` (${lanePart})` : "";
    }

    return (
        <>
            <p className={`text-[16px] font-bold text-white p-2 bg-[#A7B1C2]  mb-0`}>
                Passagem <b>{data.plate}</b>
            </p>
            <div className={"p-2"}>
                <DivisorItem icon={<FaCalendar size={18}/>} text={"Data/hora da passagem"} value={projectUtils.formatDate(data.procCaptureTime)}/>
                <DivisorItem icon={<FaLocationDot size={18}/>} text={"Local"} value={data.capturePlaceDescription}/>
                <DivisorItem icon={<FaCamera size={18}/>} text={"Câmera/Sentido"} value={cameraDetails()}/>
                <DivisorItem icon={<FaLocationDot size={18}/>} text={"Latitude/Longitude"} value={[data.lat, data.lng].join(", ")}/>
            </div>
        </>
    )
};

export default PassageDetails;